/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-return-assign */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/sort-comp */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable react/no-unused-state */
/* eslint-disable react/state-in-constructor */
/**
 * React wrapper for Bryntum Gantt
 */
import { Gantt } from '@bryntum/gantt/gantt.module';
import React, { Component } from 'react';
import { WrapperHelper } from './wrapper-helper';

export class BryntumGantt extends Component {
  static instanceClass = Gantt;

  // Component is View class
  static isView = true;

  dataStores = { taskStore: 'tasks' };

  featureNames = [
    'baselinesFeature',
    'cellEditFeature',
    'cellMenuFeature',
    'cellTooltipFeature',
    'columnAutoWidthFeature',
    'columnDragToolbarFeature',
    'columnLinesFeature',
    'columnPickerFeature',
    'columnReorderFeature',
    'columnResizeFeature',
    'contextMenuFeature',
    'criticalPathsFeature',
    'dependenciesFeature',
    'dependencyEditFeature',
    'eventContextMenuFeature',
    'eventCopyPasteFeature',
    'eventDragCreateFeature',
    'eventDragFeature',
    'eventDragSelectFeature',
    'eventEditFeature',
    'eventFilterFeature',
    'eventMenuFeature',
    'eventTooltipFeature',
    'excelExporterFeature',
    'filterBarFeature',
    'filterFeature',
    'groupFeature',
    'groupSummaryFeature',
    'headerContextMenuFeature',
    'headerMenuFeature',
    'headerZoomFeature',
    'indicatorsFeature',
    'labelsFeature',
    'mspExportFeature',
    'nonWorkingTimeFeature',
    'panFeature',
    'pdfExportFeature',
    'percentBarFeature',
    'progressLineFeature',
    'projectLinesFeature',
    'quickFindFeature',
    'regionResizeFeature',
    'resourceNonWorkingTimeFeature',
    'resourceTimeRangesFeature',
    'rollupsFeature',
    'rowCopyPasteFeature',
    'rowReorderFeature',
    'scheduleContextMenuFeature',
    'scheduleMenuFeature',
    'scheduleTooltipFeature',
    'searchFeature',
    'simpleEventEditFeature',
    'sortFeature',
    'stickyEventsFeature',
    'stripeFeature',
    'summaryFeature',
    'taskContextMenuFeature',
    'taskCopyPasteFeature',
    'taskDragCreateFeature',
    'taskDragFeature',
    'taskEditFeature',
    'taskMenuFeature',
    'taskResizeFeature',
    'taskTooltipFeature',
    'timeAxisHeaderMenuFeature',
    'timeRangesFeature',
    'treeFeature',
  ];

  // Hidden div to host unused portals DOM
  portalsCache = undefined;

  // CSS class used for individual portal containers
  portalContainerClass = 'b-react-portal-container';

  state = {
    // Holds React portals
    portals: new Map(),

    // Needed to trigger refresh when portals change
    generation: 0,
  };

  configNames = [
    'adopt',
    'align',
    'allowCreate',
    'allowOver',
    'anchor',
    'anchorToTarget',
    'animateRemovingRows',
    'appendTo',
    'autoAdjustTimeAxis',
    'autoClose',
    'autoHeight',
    'autoShow',
    'bbar',
    'bodyCls',
    'bubbleEvents',
    'bufferCoef',
    'bufferThreshold',
    'centered',
    'closable',
    'closeAction',
    'cls',
    'columns',
    'config',
    'constrainTo',
    'contentElementCls',
    'contextMenuTriggerEvent',
    'createEventOnDblClick',
    'creationTooltip',
    'defaultBindProperty',
    'defaultRegion',
    'defaultResourceImageName',
    'defaults',
    'dependencyIdField',
    'destroyStore',
    'disableGridRowModelWarning',
    'dismissDelay',
    'dock',
    'draggable',
    'durationDisplayPrecision',
    'emptyText',
    'enableDeleteKey',
    'enableEventAnimations',
    'enableRecurringEvents',
    'enableSticky',
    'enableTextSelection',
    'enableUndoRedoKeys',
    'eventColor',
    'eventStyle',
    'features',
    'fillLastColumn',
    'fixedRowHeight',
    'floating',
    'focusOnToFront',
    'footer',
    'forceFit',
    'forElement',
    'forSelector',
    'fullRowRefresh',
    'getDateConstraints',
    'getHtml',
    'getRowHeight',
    'header',
    'hideAnimation',
    'hideDelay',
    'hideHeaders',
    'hideOnDelegateChange',
    'hideWhenEmpty',
    'hoverDelay',
    'htmlCls',
    'infiniteScroll',
    'insertBefore',
    'insertFirst',
    'itemCls',
    'lazyItems',
    'listeners',
    'loadingMsg',
    'loadMask',
    'loadMaskDefaults',
    'loadMaskError',
    'localeClass',
    'localizableProperties',
    'longPressTime',
    'managedEventSizing',
    'maskDefaults',
    'masked',
    'maximizable',
    'maximized',
    'modal',
    'monitorResize',
    'mouseOffsetX',
    'mouseOffsetY',
    'namedItems',
    'owner',
    'partner',
    'plugins',
    'positioned',
    'preserveFocusOnDatasetChange',
    'preserveScrollOnDatasetChange',
    'preventTooltipOnTouch',
    'resizeToFitIncludesHeader',
    'resourceImageFolderPath',
    'responsiveLevels',
    'ripple',
    'rootElement',
    'scrollAction',
    'scrollerClass',
    'scrollManager',
    'selectionMode',
    'showAnimation',
    'showCreationTooltip',
    'showDirty',
    'showOnClick',
    'showOnHover',
    'showRemoveRowInContextMenu',
    'snapRelativeToEventStartDate',
    'stickyHeaders',
    'strips',
    'subGridConfigs',
    'suppressFit',
    'syncMask',
    'tab',
    'tag',
    'taskRenderer',
    'tbar',
    'terminalCls',
    'terminalSides',
    'textAlign',
    'textContent',
    'timeAxis',
    'title',
    'trapFocus',
    'visibleDate',
    'visibleZoomFactor',
    'weekStartDay',
    'weight',
    'zoomKeepsOriginalTimespan',
    'zoomOnMouseWheel',
    'zoomOnTimeAxisDoubleClick',
  ];

  propertyConfigNames = [
    'alignSelf',
    'allowDropOnEventBar',
    'barMargin',
    'columnLines',
    'content',
    'data',
    'dataset',
    'disabled',
    'displayDateFormat',
    'endDate',
    'extraData',
    'flex',
    'height',
    'hidden',
    'html',
    'id',
    'items',
    'layout',
    'layoutStyle',
    'margin',
    'maxHeight',
    'maxWidth',
    'maxZoomLevel',
    'minHeight',
    'minWidth',
    'minZoomLevel',
    'onAfterDependencyCreateDrop',
    'onAfterDragCreate',
    'onAfterEventSave',
    'onAfterTaskDrop',
    'onAfterTaskSave',
    'onBeforeAssignmentDelete',
    'onBeforeCellEditStart',
    'onBeforeDependencyCreateDrag',
    'onBeforeDependencyCreateFinalize',
    'onBeforeDestroy',
    'onBeforeDragCreate',
    'onBeforeDragCreateFinalize',
    'onBeforeEventDelete',
    'onBeforeEventResize',
    'onBeforeEventResizeFinalize',
    'onBeforeEventSave',
    'onBeforeFinishCellEdit',
    'onBeforeHide',
    'onBeforePresetChange',
    'onBeforeRenderRows',
    'onBeforeSetRecord',
    'onBeforeShow',
    'onBeforeTaskDelete',
    'onBeforeTaskDrag',
    'onBeforeTaskDropFinalize',
    'onBeforeTaskEdit',
    'onBeforeTaskEditShow',
    'onBeforeTaskResize',
    'onBeforeTaskResizeFinalize',
    'onBeforeTaskSave',
    'onBeforeToggleNode',
    'onCancelCellEdit',
    'onCatchAll',
    'onCellClick',
    'onCellContextMenu',
    'onCellDblClick',
    'onCellMouseOut',
    'onCellMouseOver',
    'onCollapseNode',
    'onDependencyClick',
    'onDependencyCreateDragStart',
    'onDependencyCreateDrop',
    'onDependencyDblClick',
    'onDependencyMouseOut',
    'onDependencyMouseOver',
    'onDependencyValidationComplete',
    'onDependencyValidationStart',
    'onDestroy',
    'onDragCreateEnd',
    'onDragCreateStart',
    'onEventPartialResize',
    'onEventResizeEnd',
    'onEventResizeStart',
    'onExpandNode',
    'onFinishCellEdit',
    'onFocusIn',
    'onFocusOut',
    'onHide',
    'onMouseOut',
    'onMouseOver',
    'onNavigate',
    'onPaint',
    'onPresetChange',
    'onReadOnly',
    'onReleaseTask',
    'onRenderRows',
    'onRenderTask',
    'onResize',
    'onResponsive',
    'onScroll',
    'onSelectionChange',
    'onShow',
    'onStartCellEdit',
    'onTaskClick',
    'onTaskContextMenu',
    'onTaskDblClick',
    'onTaskDrag',
    'onTaskDragStart',
    'onTaskDrop',
    'onTaskKeyDown',
    'onTaskKeyUp',
    'onTaskMouseDown',
    'onTaskMouseOut',
    'onTaskMouseOver',
    'onTaskMouseUp',
    'onTaskPartialResize',
    'onTaskResizeEnd',
    'onTaskResizeStart',
    'onTimeAxisChange',
    'onTimeAxisHeaderClick',
    'onTimeAxisHeaderContextMenu',
    'onTimeAxisHeaderDblClick',
    'onTimelineViewportResize',
    'onToggleNode',
    'onToolClick',
    'presets',
    'project',
    'readOnly',
    'rowHeight',
    'scrollable',
    'snap',
    'startDate',
    'store',
    'tasks',
    'taskStore',
    'tickSize',
    'toggleParentTasksOnClick',
    'tools',
    'tooltip',
    'transitionDuration',
    'viewPreset',
    'width',
    'workingTime',
    'x',
    'y',
  ];

  propertyNames = [
    'anchorSize',
    'eventColors',
    'eventStyles',
    'isSettingValues',
    'isValid',
    'record',
    'scrollLeft',
    'scrollTop',
    'selectedCell',
    'selectedRecord',
    'selectedRecords',
    'state',
    'timeResolution',
    'values',
    'zoomLevel',
  ];

  // Component instance
  instance = undefined;

  // Component element
  element = undefined;

  /**
   * Invoked immediately after a component is mounted (inserted into the tree)
   */
  componentDidMount() {
    const { createWidget } = WrapperHelper();

    this.instance = createWidget(this);
  }

  // React component removed, destroy instance
  componentWillUnmount() {
    if (this.instance) {
      this.instance.destroy();
    }
  }

  /**
   * Component about to be updated, from changing a prop using state.
   * React to it depending on what changed and prevent react from re-rendering our component.
   * @param nextProps
   * @param nextState
   * @return {boolean}
   */
  shouldComponentUpdate(nextProps, nextState) {
    const { shouldComponentUpdate } = WrapperHelper();

    return shouldComponentUpdate(this, nextProps, nextState);
  }

  render() {
    const className = `b-react-${this.constructor.instanceClass.$name.toLowerCase()}-container`;

    return (
      <>
        <div className={className} ref={(element) => (this.element = element)}>
          {[...this.state.portals].map((item) => item[1])}
        </div>
        <div
          ref={(el) => (this.portalsCache = el)}
          className="b-react-portals-cache"
          style={{ display: 'none' }}
        />
      </>
    );
  }
}
